/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { PlaceholderText, Stack } from 'sarsaparilla';

export default function HeaderPlaceholder() {
    return (
        <div className="ia-header-placeholder">
            <Stack space="xs">
                <div className="ia-header-placeholder-title">
                    <PlaceholderText
                        fontSize={33}
                        lineHeight={33 * 1.2}
                        lines={1}
                        width="30%"
                    />
                </div>
                <div className="ia-header-placeholder-subtitle">
                    <PlaceholderText
                        fontSize={16}
                        lineHeight={16 * 1.2}
                        lines={1}
                        width="60%"
                    />
                </div>
                <div className="ia-header-placeholder-description">
                    <PlaceholderText fontSize={14} lineHeight={14 * 1.7} lines={3} />
                </div>
            </Stack>
        </div>
    );
}
